// HERO.JS- (Cross - Utilization)-
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faDatabase,
  faCreditCard,
  faEyeLowVision,
  faBuildingColumns,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import Swal from "sweetalert2";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { AreaChart, DonutChart } from "./chart/chart";
import { Bar } from "react-chartjs-2"; // Import Bar chart
import MyMapComponent from "./MyMapComponent";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Link } from "react-router-dom";
import { Line } from "react-chartjs-2";
import TrackkPopup from "./trackkflow";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  LineElement,
  PointElement,
);

export default function Hero() {
  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showTrackkPanel, setShowTrackkPanel] = useState(false);
  const [driverCount, setDriverCount] = useState(0);
  const [leaseCount, setLeaseCount] = useState(0);

  const [vehicleCount, setVehicleCount] = useState(0);
  const [vehicleCounts, setVehicleCounts] = useState(0);
  const [serviceCenterCount, setServiceCenterCount] = useState(0);

  const [hubCount, setHubCount] = useState(0);
  const [clientCount, setClientCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [generalStaffCount, setGeneralStaffCount] = useState(0);
  const [totalKm, setTotalKm] = useState(0);
  const [dailyKm, setDailykm] = useState(0);
  const [rerendarApi, setRerendarApi] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const tokennew = "your-token"; // Replace with your actual token
  const [presentCount, setPresentCount] = useState(0);
  const [absentCount, setAbsentCount] = useState(0);
  const [staffLeaveCount, setStaffLeaveCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [crossCount, setCrossCount] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [revenueCount, setRevenueCount] = useState(0);
  const [fixedrevenueCount, setFixedRevenueCount] = useState(0);
  const [pprevenueCount, setPpRevenueCount] = useState(0);
  const [fixedTripsCount, setFixedTripsCount] = useState(0);
  const [ppTripsCount, setPpTripsCount] = useState(0);
  const [weeklyTrend, setWeeklyTrend] = useState([]);
  const [peakRevenue, setPeakRevenue] = useState(0);
  const [peakRevenueDate, setPeakRevenueDate] = useState(null);
  const [fromDate, setFromDate] = useState(
    moment().subtract(6, "days").format("YYYY-MM-DD"),
  );
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [dailyRevenue, setDailyRevenue] = useState(0);
  const [driverPresentCount, setDriverPresentCount] = useState(0);
  const [driverAbsentCount, setDriverAbsentCount] = useState(0);
  const [driverLeaveCount, setDriverLeaveCount] = useState(0);
  const [driverManualCount, setDriverManualCount] = useState(0);
  const [todayLeaveMap, setTodayLeaveMap] = useState({});
  const [complianceCount, setComplianceCount] = useState(0);
  const [directExpense, setDirectExpense] = useState(0);
  const [indirectExpense, setIndirectExpense] = useState(0);

  const [earlyCount, setEarlyCount] = useState(0);
  const [lateCount, setLateCount] = useState(0);
  const [onTimeCount, setOnTimeCount] = useState(0);
  const [showRevenueTrend, setShowRevenueTrend] = useState(false);
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  useEffect(() => {
    if (showTrackkPanel) {
      // Reset all cards to hidden first
      const cards = document.querySelectorAll(".feature-card");
      cards.forEach((card) => card.classList.remove("visible"));

      // Then stagger them in one by one, 180ms apart
      cards.forEach((card, i) => {
        setTimeout(() => {
          card.classList.add("visible");
        }, i * 330);
      });
    }
  }, [showTrackkPanel]);

  const fetchWeeklyTrend = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/revenue-trends`,
        {
          params: {
            fromDate,
            toDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setWeeklyTrend(response.data.data);
      setPeakRevenue(response.data.summary.peakRevenue);
      setPeakRevenueDate(response.data.summary.peakRevenueDate);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWeeklyTrend();
  }, [fromDate, toDate]);

  const exportRevenueTrend = () => {
    try {
      const excelData = weeklyTrend.map((item) => ({
        Date: moment(item.date).format("DD MMM YYYY"),
        Revenue: item.revenue,
        "Total Trips": item.totalTrips,
        "Fixed Trips": item.fixedTrips,
        "PP Trips": item.ppTrips,
        "Fixed Amount": item.fixedAmount,
        "PP Amount": item.ppAmount,
        Performance: item.isPeakRevenue
          ? "Peak Revenue"
          : `${item.performance.toFixed(1)}%`,
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Trend");

      XLSX.writeFile(workbook, `Revenue_Trend_${fromDate}_to_${toDate}.xlsx`);
    } catch (error) {
      console.error("Export Error:", error);
    }
  };

  useEffect(() => {
    const fetchTodayLeaves = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/leave-requests`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD
        const leaveMap = {};

        res.data?.leaveRequests?.forEach((leave) => {
          const userId = leave.id_user?._id;
          if (!userId) return;

          // Only Approved or Pending
          if (!["Approved", "Pending"].includes(leave.status)) return;

          const startDate = new Date(leave.startDate).toLocaleDateString(
            "en-CA",
          );
          const endDate = new Date(leave.endDate).toLocaleDateString("en-CA");

          if (today >= startDate && today <= endDate) {
            leaveMap[userId] = true;
          }
        });

        setTodayLeaveMap(leaveMap);
      } catch (error) {
        console.error("❌ Leave fetch error:", error);
      }
    };

    fetchTodayLeaves();
  }, []);

  useEffect(() => {
    const hasSeen = localStorage.getItem("hasSeenTrackk");

    if (!hasSeen) {
      setShowPopup(true); // ✅ Auto-show on first login
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    localStorage.setItem("hasSeenTrackk", "true");
  };

  const openPopup = () => {
    setShowPopup(true);
  };

  const openTrackkDemo = () => {
    window.open(
      "https://youtube.com/shorts/ukqD0hUud9U",
      "_blank",
      "noopener,noreferrer",
    );
  };

  const userRole = localStorage.getItem("userRole");
  const getRandomLightGrey = () => {
    const shade = Math.floor(Math.random() * 45) + 200; // Range: 200–245
    return `rgb(${shade}, ${shade}, ${shade})`;
  };

  const [statusChartData, setStatusChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Active",
        backgroundColor: "#4CAF50",
        data: [],
      },
      {
        label: "Inactive",
        backgroundColor: "#F44336",
        data: [],
      },
      {
        label: "Unassigned",
        backgroundColor: "#FFC107",
        data: [],
      },
      {
        label: "Service Centre",
        backgroundColor: "#2196F3",
        data: [],
      },
    ],
  });

  const [barChartData, setBarChartData] = useState({
    labels: [],
    datasets: [],
  });

  const [chartDatan, setChartDatan] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  const [movingChartData, setMovingChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  const [notMovingChartData, setNotMovingChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  const [userStatusChartData, setUserStatusChartData] = useState({
    labels: ["Present", "Absent"],
    datasets: [
      {
        data: [presentCount, absentCount],
        // backgroundColor: ["#4CAF50", "#F44336"], // Green for Present, Red for Absent
        backgroundColor: ["#f44336", "#D4D4D4"],
      },
    ],
  });

  // const driverStatusChartData = {
  //   labels: ["Present", "Absent"],
  //   datasets: [
  //     {
  //       label: "Driver Attendance",
  //       data: [driverPresentCount, driverAbsentCount],
  //       // backgroundColor: ["#28a745", "#dc3545"],
  //       backgroundColor: ["#90ee90", "#92cbdf"],
  //       borderWidth: 1,
  //     },
  //   ],
  // };
  const driverStatusChartData = {
    // labels: ["Present", "Absent", "On Leave", "Manual Attendance"],
    labels: ["Present", "Absent", "On Leave"],

    datasets: [
      {
        label: "Driver Attendance",
        data: [
          driverPresentCount,
          driverAbsentCount,
          driverLeaveCount,
          // driverManualCount,
        ],
        // backgroundColor: ["#90ee90", "#ffb6b6", "#92cbdf", "#f4d03f"],
        backgroundColor: ["#90ee90", "#ffb6b6", "#92cbdf"],

        borderWidth: 1,
      },
    ],
  };

  const weeklyRevenueChart = {
    labels: weeklyTrend.map((item) => moment(item.date).format("DD MMM")),

    datasets: [
      {
        label: "Revenue",
        // data: weeklyTrend.map((item) => item.total),
        data: weeklyTrend.map((item) => item.revenue),
        borderColor: "#2563eb",
        backgroundColor: "#2563eb",
        tension: 0.4,
      },
    ],
  };

  const weeklyTripChart = {
    labels: weeklyTrend.map((item) => moment(item.date).format("DD MMM")),

    datasets: [
      {
        label: "Trips",
        data: weeklyTrend.map((item) => item.totalTrips),
        backgroundColor: "#2563eb",
      },
      {
        label: "Fixed Trips",
        data: weeklyTrend.map((item) => item.fixedTrips),
        backgroundColor: "#16a34a",
      },
      {
        label: "PP Trips",
        data: weeklyTrend.map((item) => item.ppTrips),
        backgroundColor: "#f97316",
      },
    ],
  };

  // const [crossUtilizationChartData, setCrossUtilizationChartData] = useState({
  //   labels: ["Total ", "Cross"],
  //   datasets: [
  //     {
  //       // data: [presentCount, absentCount],

  //       backgroundColor: ["#4CAF50", "#F44336"], // Green for Present, Red for Absent
  //     },
  //   ],
  // });
  const [crossUtilizationChartData, setCrossUtilizationChartData] = useState({
    labels: [],
    datasets: [],
  });
  const getDatesTillToday = () => {
    const dates = [];
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0-based
    const todayDate = today.getDate();

    for (let day = 1; day <= todayDate; day++) {
      const date = new Date(year, month, day);

      // Format as YYYY-MM-DD using local time
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const localDate = `${yyyy}-${mm}-${dd}`;

      dates.push(localDate);
    }

    return dates;
  };

  const [vehiclestatusChartData, setVehicleStatusChartData] = useState({
    labels: ["Moving", "Not Moving"],
    datasets: [
      {
        data: [0, 0],
        // backgroundColor: ["#4CAF50", "#F44336"], // Green for Moving, Red for Not Moving
        backgroundColor: ["#ECECEC", "#D4D4D4"],
      },
    ],
  });

  const token = localStorage.getItem("token");

  // useEffect(() => {
  //   const fetchVehicles = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const userRole = localStorage.getItem("userRole"); // Get user role

  //       if (!token) {
  //         console.error("No token found");
  //         return;
  //       }

  //       // Determine API URL based on user role
  //       let apiUrl;
  //       if (userRole === "superadmin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
  //       } else if (userRole === "admin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
  //       } else if (userRole === "clientmanager") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
  //       } else {
  //         console.error("Unauthorized role:", userRole);
  //         return;
  //       }

  //       // Fetch data from the authorized API
  //       const response = await axios.get(apiUrl, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (Array.isArray(response.data.vehicles)) {
  //         // Filter only Active vehicles
  //         const activeVehicles = response.data.vehicles.filter(
  //           (vehicle) => vehicle.status === "Active"
  //         );

  //         // Group vehicles by company and calculate moving/not-moving stats
  //         const companyData = activeVehicles.reduce((acc, vehicle) => {
  //           const company = vehicle.id_type?.company || "Unknown";

  //           if (!acc[company]) {
  //             acc[company] = { moving: 0, notMoving: 0 };
  //           }

  //           const today = new Date().toLocaleDateString();
  //           const checkInDate = vehicle.shift_hours?.check_in
  //             ? new Date(vehicle.shift_hours.check_in).toLocaleDateString()
  //             : null;
  //           const checkOutDate = vehicle.shift_hours?.check_out
  //             ? new Date(vehicle.shift_hours.check_out).toLocaleDateString()
  //             : null;

  //           const isMoving =
  //             vehicle.dailyKm !== 0 ||
  //             vehicle.vehiclestatus === "Moving" ||
  //             (checkInDate === today && checkOutDate === today) ||
  //             checkInDate === today;

  //           if (isMoving) {
  //             acc[company].moving++;
  //           } else {
  //             acc[company].notMoving++;
  //           }

  //           return acc;
  //         }, {});

  //         // Prepare data for the Pie Charts
  //         const labels = Object.keys(companyData); // Company names
  //         const movingData = labels.map(
  //           (company) => companyData[company].moving
  //         ); // Moving vehicles count
  //         const notMovingData = labels.map(
  //           (company) => companyData[company].notMoving
  //         ); // Not moving vehicles count

  //         const generateColors = (count) =>
  //           Array.from(
  //             { length: count },
  //             () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
  //           );

  //         // Update Moving Vehicles Pie Chart
  //         setMovingChartData({
  //           labels,
  //           datasets: [
  //             {
  //               label: "Moving Vehicles",
  //               data: movingData,
  //               backgroundColor: generateColors(labels.length),
  //             },
  //           ],
  //         });

  //         // Update Not Moving Vehicles Pie Chart
  //         setNotMovingChartData({
  //           labels,
  //           datasets: [
  //             {
  //               label: "Not Moving Vehicles",
  //               data: notMovingData,
  //               backgroundColor: generateColors(labels.length),
  //             },
  //           ],
  //         });
  //       } else {
  //         console.error("Unexpected API response", response.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching vehicle data: ", error);
  //     }
  //   };

  //   fetchVehicles();
  // }, [token]); // Ensures API call runs when token changes

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on user role
        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        // Fetch data
        const response = await axios.get(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.vehicles)) {
          // Filter active vehicles
          const activeVehicles = response.data.vehicles.filter(
            (vehicle) => vehicle.status === "Active",
          );

          // Group by company and calculate movement stats
          const companyData = activeVehicles.reduce((acc, vehicle) => {
            const company = vehicle.id_type?.company || "Unknown";

            if (!acc[company]) {
              acc[company] = { moving: 0, notMoving: 0 };
            }

            const today = new Date().toLocaleDateString();
            const checkInDate = vehicle.shift_hours?.check_in
              ? new Date(vehicle.shift_hours.check_in).toLocaleDateString()
              : null;
            const checkOutDate = vehicle.shift_hours?.check_out
              ? new Date(vehicle.shift_hours.check_out).toLocaleDateString()
              : null;

            const isMoving =
              vehicle.dailyKm !== 0 ||
              vehicle.vehiclestatus === "Moving" ||
              (checkInDate === today && checkOutDate === today) ||
              checkInDate === today;

            if (isMoving) {
              acc[company].moving++;
            } else {
              acc[company].notMoving++;
            }

            return acc;
          }, {});

          // Prepare data
          const labels = Object.keys(companyData);
          const movingData = labels.map(
            (company) => companyData[company].moving,
          );
          const notMovingData = labels.map(
            (company) => companyData[company].notMoving,
          );

          // ✅ Use pastel HSL colors
          const generatePastelColors = (count) =>
            Array.from({ length: count }, () => {
              const hue = Math.floor(Math.random() * 360);
              return `hsl(${hue}, 70%, 75%)`; // Light pastel color
            });

          // Set chart data
          setMovingChartData({
            labels,
            datasets: [
              {
                label: "Moving Vehicles",
                data: movingData,
                backgroundColor: generatePastelColors(labels.length),
              },
            ],
          });

          setNotMovingChartData({
            labels,
            datasets: [
              {
                label: "Not Moving Vehicles",
                data: notMovingData,
                backgroundColor: generatePastelColors(labels.length),
              },
            ],
          });
        } else {
          console.error("Unexpected API response", response.data);
        }
      } catch (error) {
        console.error("Error fetching vehicle data: ", error);
      }
    };

    fetchVehicles();
  }, []); // Removed [token] because token is fetched inside the effect

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.vehicles)) {
          const allVehicles = response.data.vehicles;
          const today = new Date().toLocaleDateString();

          // Filter only "Active" vehicles
          const activeVehicles = allVehicles.filter(
            (vehicle) => vehicle.status === "Active",
          );

          // Determine "Moving" vehicles
          const movingVehicles = activeVehicles.filter((vehicle) => {
            const checkInDate = vehicle.shift_hours?.check_in
              ? new Date(vehicle.shift_hours.check_in).toLocaleDateString()
              : null;
            const checkOutDate = vehicle.shift_hours?.check_out
              ? new Date(vehicle.shift_hours.check_out).toLocaleDateString()
              : null;

            return (
              vehicle.dailyKm !== 0 ||
              vehicle.vehiclestatus === "Moving" ||
              (checkInDate === today && checkOutDate === today) ||
              checkInDate === today
            );
          });

          // Calculate "Not-Moving" vehicles
          const notMovingVehicles = activeVehicles.filter((vehicle) => {
            const checkInDate = vehicle.shift_hours?.check_in
              ? new Date(vehicle.shift_hours.check_in).toLocaleDateString()
              : null;
            const checkOutDate = vehicle.shift_hours?.check_out
              ? new Date(vehicle.shift_hours.check_out).toLocaleDateString()
              : null;

            return !(
              vehicle.dailyKm !== 0 ||
              vehicle.vehiclestatus === "Moving" ||
              (checkInDate === today && checkOutDate === today) ||
              checkInDate === today
            );
          });

          // Update chart data
          setVehicleStatusChartData({
            labels: ["Moving", "Not Moving"],
            datasets: [
              {
                data: [movingVehicles.length, notMovingVehicles.length],
                // backgroundColor: ["#4CAF50", "#F44336"], // Green for Moving, Red for Not Moving
                backgroundColor: ["#90ee90", "#92cbdf"],
              },
            ],
          });
        } else {
          console.error("Unexpected data format from API", response.data);
        }
      } catch (error) {
        console.error("Error fetching vehicle data: ", error);
      }
    };

    fetchVehicles();
  }, [token]); // Refetch if token changes

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const vehicles = response.data.vehicles || [];

        // Group vehicles by company and status
        const groupedData = vehicles.reduce((acc, vehicle) => {
          const company = vehicle.id_type?.company || "Unknown";
          const status = vehicle.status || "Unknown";
          if (!acc[company]) {
            acc[company] = {
              active: 0,
              unassigned: 0,
              servicecentre: 0,
            };
          }

          // Increment the count based on the vehicle status
          if (status === "Active") acc[company].active++;
          if (status === "Unassigned") acc[company].unassigned++;
          if (status === "Service_Center") acc[company].servicecentre++;

          return acc;
        }, {});

        // Prepare data for the multi-bar chart
        const companyLabels = Object.keys(groupedData);
        const activeData = companyLabels.map(
          (company) => groupedData[company].active || 0,
        );
        const unassignedData = companyLabels.map(
          (company) => groupedData[company].unassigned || 0,
        );
        const servicecentreData = companyLabels.map(
          (company) => groupedData[company].servicecentre || 0,
        );

        setBarChartData({
          labels: companyLabels,
          datasets: [
            {
              label: "Active",
              backgroundColor: "#4CAF50",
              data: activeData,
            },
            {
              label: "Unassigned",
              backgroundColor: "#FFC107",
              data: unassignedData,
            },
            {
              label: "Service Centre",
              backgroundColor: "#2196F3",
              data: servicecentreData,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };

    fetchVehicles();
  }, [token]);

  // useEffect(() => {
  //   const fetchVehicleData = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const userRole = localStorage.getItem("userRole");

  //       if (!token) {
  //         console.error("No token found");
  //         return;
  //       }

  //       // Determine API URL based on user role
  //       let apiUrl;
  //       if (userRole === "superadmin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
  //       } else if (userRole === "admin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
  //       } else if (userRole === "clientmanager") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
  //       } else {
  //         console.error("Unauthorized role:", userRole);
  //         return;
  //       }

  //       const response = await axios.get(apiUrl, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (!response.data || !Array.isArray(response.data.vehicles)) {
  //         console.error("Unexpected API response format", response.data);
  //         return;
  //       }

  //       const vehicles = response.data.vehicles;

  //       // Exclude "Inactive", "Unassigned", "Service_Center" vehicles
  //       const activeVehiclesForCompany = vehicles.filter(
  //         (vehicle) =>
  //           !["Inactive", "Unassigned", "Service_Center"].includes(
  //             vehicle.status
  //           )
  //       );

  //       setVehicleCount(activeVehiclesForCompany.length);

  //       // Company Distribution Calculation
  //       const groupedCompanyData = activeVehiclesForCompany.reduce(
  //         (acc, vehicle) => {
  //           const company = vehicle.id_type?.company || "Unknown";
  //           acc[company] = (acc[company] || 0) + 1;
  //           return acc;
  //         },
  //         {}
  //       );

  //       const companyLabels = Object.keys(groupedCompanyData);
  //       const companyData = Object.values(groupedCompanyData);
  //       const companyColors = companyLabels.map(
  //         () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
  //       );

  //       setChartData({
  //         labels: companyLabels,
  //         datasets: [{ data: companyData, backgroundColor: companyColors }],
  //       });

  //       // Vehicle Status Distribution
  //       const groupedStatusData = vehicles.reduce((acc, vehicle) => {
  //         const status = vehicle.status || "Unknown";
  //         acc[status] = (acc[status] || 0) + 1;
  //         return acc;
  //       }, {});

  //       const statusLabels = Object.keys(groupedStatusData);
  //       const statusData = Object.values(groupedStatusData);
  //       const statusColors = statusLabels.map(
  //         () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
  //       );

  //       setStatusChartData({
  //         labels: statusLabels,
  //         datasets: [{ data: statusData, backgroundColor: statusColors }],
  //       });
  //     } catch (error) {
  //       console.error("Error fetching vehicle data:", error);
  //     }
  //   };

  //   fetchVehicleData();
  // }, []);

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on user role
        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.data || !Array.isArray(response.data.vehicles)) {
          console.error("Unexpected API response format", response.data);
          return;
        }

        const vehicles = response.data.vehicles;

        // Exclude "Inactive", "Unassigned", "Service_Center" vehicles
        const activeVehiclesForCompany = vehicles.filter(
          (vehicle) =>
            !["Inactive", "Unassigned", "Service_Center"].includes(
              vehicle.status,
            ),
        );
        const serviceCenterVehicles = vehicles.filter(
          (vehicle) => vehicle.status === "Service_Center",
        );
        setServiceCenterCount(serviceCenterVehicles.length);

        setVehicleCount(activeVehiclesForCompany.length);

        // Company Distribution Calculation
        const groupedCompanyData = activeVehiclesForCompany.reduce(
          (acc, vehicle) => {
            const company = vehicle.id_type?.company || "Unknown";
            acc[company] = (acc[company] || 0) + 1;
            return acc;
          },
          {},
        );

        const companyLabels = Object.keys(groupedCompanyData);
        const companyData = Object.values(groupedCompanyData);

        const companyColors = companyLabels.map(() => {
          const hue = Math.floor(Math.random() * 360);
          return `hsl(${hue}, 70%, 75%)`; // Light pastel color
        });

        setChartData({
          labels: companyLabels,
          datasets: [
            {
              data: companyData,
              backgroundColor: companyColors,
            },
          ],
        });

        // Vehicle Status Distribution
        const groupedStatusData = vehicles.reduce((acc, vehicle) => {
          const status = vehicle.status || "Unknown";
          acc[status] = (acc[status] || 0) + 1;
          return acc;
        }, {});

        const statusLabels = Object.keys(groupedStatusData);
        const statusData = Object.values(groupedStatusData);

        const statusColors = statusLabels.map(() => {
          const hue = Math.floor(Math.random() * 360);
          return `hsl(${hue}, 70%, 75%)`; // Light pastel color
        });

        setStatusChartData({
          labels: statusLabels,
          datasets: [
            {
              data: statusData,
              backgroundColor: statusColors,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };

    fetchVehicleData();
  }, []);
  // useEffect(() => {
  //   const fetchUsers = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const userRole = localStorage.getItem("userRole");

  //       if (!token) {
  //         console.error("No token found");
  //         return;
  //       }

  //       let apiUrl;
  //       if (userRole === "superadmin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`;
  //       } else if (userRole === "admin") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/users`;
  //       } else if (userRole === "clientmanager") {
  //         apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/users`;
  //       } else {
  //         console.error("Unauthorized role:", userRole);
  //         return;
  //       }

  //       const response = await axios.get(apiUrl, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (Array.isArray(response.data.users)) {
  //         const users = response.data.users;
  //         let present = 0;
  //         let absent = 0;
  //         let driverPresent = 0;
  //         let driverAbsent = 0;
  //         const today = new Date();
  //         const startOfDay = new Date(today.setHours(0, 0, 0, 0));
  //         const endOfDay = new Date(today.setHours(23, 59, 59, 999));

  //         users.forEach((user) => {
  //           // if (user.status === "Active") {
  //           //   const check_in = user?.attendance?.check_in;
  //           //   const isCheckedInToday =
  //           //     check_in &&
  //           //     new Date(check_in) >= startOfDay &&
  //           //     new Date(check_in) <= endOfDay;

  //           //   if (isCheckedInToday) present++;
  //           //   else absent++;
  //           // }
  //           const isStaff = user?.id_generalStaffType?.name != "Driver";
  //           const isActive = user.status === "Active";

  //           if (isStaff && isActive) {
  //             const check_in = user?.attendance?.check_in;
  //             const checkInDate = check_in && new Date(check_in);
  //             const isCheckedInToday =
  //               checkInDate &&
  //               checkInDate >= startOfDay &&
  //               checkInDate <= endOfDay;

  //             if (isCheckedInToday) present++;
  //             else absent++;
  //           }
  //         });
  //         users.forEach((user) => {
  //           const isDriver = user?.id_generalStaffType?.name === "Driver";
  //           const isActive = user.status === "Active";

  //           if (isDriver && isActive) {
  //             const check_in = user?.attendance?.check_in;
  //             const checkInDate = check_in && new Date(check_in);
  //             const isCheckedInToday =
  //               checkInDate &&
  //               checkInDate >= startOfDay &&
  //               checkInDate <= endOfDay;

  //             if (isCheckedInToday) driverPresent++;
  //             else driverAbsent++;
  //           }
  //         });
  //         setDriverPresentCount(driverPresent);
  //         setDriverAbsentCount(driverAbsent);
  //         setPresentCount(present);
  //         setAbsentCount(absent);
  //         setTotalUsers(users.length);
  //       } else {
  //         console.error("Unexpected data format from API", response.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //     }
  //   };

  //   fetchUsers();
  // }, []);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");
        if (!token) return;

        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/users`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/users`;
        } else return;

        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!Array.isArray(response.data.users)) return;

        const users = response.data.users;

        let staffPresent = 0;
        let staffAbsent = 0;
        let staffLeave = 0;
        let driverManual = 0;

        let driverPresent = 0;
        let driverLeave = 0;
        let totalActiveDrivers = 0;

        const today = new Date();
        const startOfDay = new Date(today.setHours(0, 0, 0, 0));
        const endOfDay = new Date(today.setHours(23, 59, 59, 999));

        users.forEach((user) => {
          if (user.status !== "Active") return;

          const isDriver = user?.id_generalStaffType?.name === "Driver";
          const checkIn = user?.attendance?.check_in;
          const checkInDate = checkIn && new Date(checkIn);
          const checkedInToday =
            checkInDate && checkInDate >= startOfDay && checkInDate <= endOfDay;

          // ---------------- DRIVERS ----------------
          if (isDriver) {
            totalActiveDrivers++;
            if (user.manualCheckIn === true) {
              driverManual++;
            }
            // ✅ CHECK-IN HAS HIGHEST PRIORITY
            if (checkedInToday) {
              driverPresent++;
            } else if (todayLeaveMap[user._id]) {
              driverLeave++;
            }

            return;
          }

          // ---------------- STAFF ----------------
          if (checkedInToday) {
            staffPresent++;
          } else if (todayLeaveMap[user._id]) {
            staffLeave++;
          } else {
            staffAbsent++;
          }
        });

        const driverAbsent = totalActiveDrivers - (driverPresent + driverLeave);

        // 🔹 SET STATE
        setPresentCount(staffPresent);
        setAbsentCount(staffAbsent);
        setStaffLeaveCount(staffLeave);

        setDriverPresentCount(driverPresent);
        setDriverLeaveCount(driverLeave);
        setDriverAbsentCount(driverAbsent);
        setDriverManualCount(driverManual);

        setTotalUsers(users.length);
      } catch (error) {
        console.error("❌ User fetch error:", error);
      }
    };

    // if (Object.keys(todayLeaveMap).length) {
    //   fetchUsers();
    // }
    fetchUsers();
  }, [todayLeaveMap]);

  useEffect(() => {
    setUserStatusChartData({
      labels: ["Present", "Absent", "On-Leave"],
      datasets: [
        {
          data: [presentCount, absentCount, staffLeaveCount],
          // backgroundColor: ["#4CAF50", "#F44336"], // Green for Present, Red for Absent
          // backgroundColor: ["#90ee90", "#f75d59"],
          backgroundColor: ["#90ee90", "#ffb6b6", "#92cbdf"],
        },
      ],
    });
  }, [presentCount, absentCount]);

  useEffect(() => {
    const fetchMonthlyCrossUtilization = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const dates = getDatesTillToday(); // Includes today now
        console.log("Fetching data for dates:", dates);
        const labels = [];
        const crossData = [];
        const totalData = [];

        for (const date of dates) {
          const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/daily-cross-vehicle-utilization?from_date=${date}&to_date=${date}`;

          try {
            const response = await axios.get(apiUrl, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });

            const data = response.data?.data?.data;
            if (data) {
              labels.push(date.slice(-2)); // Only the day part
              crossData.push(data.vehicleCrossUtilization || 0);
              totalData.push(data.totalUtilization || 0);
            }
          } catch (err) {
            console.error(`Error on ${date}:`, err);
            labels.push(date.slice(-2));
            crossData.push(0);
            totalData.push(0);
          }
        }

        setCrossUtilizationChartData({
          labels,
          datasets: [
            {
              label: "Vehicle Cross Utilization",
              data: crossData,
              borderColor: "#F44336",
              backgroundColor: "#F44336",
              fill: false,
              tension: 0.3,
            },
            {
              label: "Total Vehicle Utilization",
              data: totalData,
              borderColor: "#4CAF50",
              backgroundColor: "#4CAF50",
              fill: false,
              tension: 0.3,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching utilization data:", error);
      }
    };

    fetchMonthlyCrossUtilization();
  }, []);

  useEffect(() => {
    setCrossUtilizationChartData({
      labels: ["Total", "Cross"],
      datasets: [
        {
          data: [totalCount, crossCount],
          backgroundColor: ["#4CAF50", "#F44336"], // Green for Present, Red for Absent
        },
      ],
    });
  }, [totalCount, crossCount]);
  const options = {
    plugins: {
      legend: {
        display: false, // Disable the legend on the chart itself
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            // Customize tooltip display if needed
            return context.label + ": " + context.formattedValue;
          },
        },
      },
    },
  };
  const option = {
    responsive: true,

    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Vehicle Count",
        },
      },
      x: {
        title: {
          display: true,
          text: "Date (Day of Month)",
        },
      },
    },
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/v3/leases`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const leases = response.data.leases;
        if (!Array.isArray(leases)) {
          console.error("Unexpected data format from API", response.data);
          return;
        }

        // Filter active leases
        const activeLeases = leases.filter(
          (lease) => lease.status?.toLowerCase() === "active",
        );

        // ✅ Calculate total leasing sum
        const totalLeasingAmount = activeLeases.reduce((sum, lease) => {
          const vehicleCount = Array.isArray(lease.id_vehicle)
            ? lease.id_vehicle.length
            : 0;
          const leasingAmount = lease.leasing_amount || 0;
          return sum + vehicleCount * leasingAmount;
        }, 0);

        setLeaseCount(totalLeasingAmount); // Rename this state to `leaseTotal` if it's more descriptive
      })
      .catch((error) => {
        console.error("Error fetching leases:", error);
      });
  }, [rerendarApi]);

  useEffect(() => {}, [leaseCount]);
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const userRole = localStorage.getItem("userRole"); // Get user role

  //   if (!token) {
  //     console.error("No token found");
  //     return;
  //   }

  //   // Determine API URL based on user role
  //   let apiUrl;
  //   if (userRole === "superadmin") {
  //     apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/drivers`;
  //   } else if (userRole === "admin") {
  //     apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/drivers`;
  //   } else if (userRole === "clientmanager") {
  //     apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/drivers`;
  //   } else {
  //     console.error("Unauthorized role:", userRole);
  //     return;
  //   }

  //   axios
  //     .get(apiUrl, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       const drivers = response.data.drivers;

  //       if (!Array.isArray(drivers)) {
  //         console.error("Unexpected data format from API", response.data);
  //         return;
  //       }

  //       // Filter only active drivers
  //       const activeDrivers = drivers.filter(
  //         (driver) => driver.status && driver.status.toLowerCase() === "active"
  //       );

  //       setDriverCount(activeDrivers.length); // Set active driver count

  //       // If API provides total count separately, you can set it here
  //       // setDriverCount(response.data.driverCount);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching driver count:", error);
  //     });
  // }, [rerendarApi, token]); // Include `token` in dependencies to ensure updates when user changes

  // useEffect(() => {}, [driverCount]);

  // VEHICLE
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token) {
          console.error("No token found");
          return;
        }

        let apiUrl = "";

        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (
          response.data &&
          response.data.vehicles &&
          Array.isArray(response.data.vehicles)
        ) {
          const vehicles = response.data.vehicles;

          // Exclude only Inactive vehicles
          const activeVehicles = vehicles.filter(
            (vehicle) =>
              vehicle.status && vehicle.status.toLowerCase() !== "inactive",
          );

          // Active vehicle count
          setVehicleCounts(activeVehicles.length);

          // Sum total KM of active vehicles
          const totalKm = activeVehicles.reduce((sum, vehicle) => {
            return sum + Number(vehicle.totalkm || 0);
          }, 0);

          setTotalKm(totalKm);

          // Sum daily KM of active vehicles
          const totalDailyKm = activeVehicles.reduce((sum, vehicle) => {
            return sum + Number(vehicle.dailyKm || 0);
          }, 0);

          setDailykm(totalDailyKm);
        } else {
          console.error("Unexpected data format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };

    fetchVehicles();
  }, [rerendarApi, token]);

  useEffect(() => {}, [vehicleCounts]);

  useEffect(() => {
    const fetchActiveUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on role
        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/users`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/users`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.users)) {
          const users = response.data.users;

          // Count active users
          const activeUsers = users.filter((user) => user.status === "Active");
          setUserCount(activeUsers.length); // Update state with active user count
        } else {
          console.error("Unexpected data format from API", response.data);
        }
      } catch (error) {
        console.error("Error fetching active users:", error);
      }
    };

    fetchActiveUsers();
  }, [rerendarApi]); // Re-run when `rer

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole"); // Get user role

    if (!token) {
      console.error("No token found");
      return;
    }

    // Define API URL based on user role
    let apiUrl;
    if (userRole === "superadmin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`;
    } else if (userRole === "admin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/hubs`;
    } else {
      console.error("Unauthorized role:", userRole);
      return;
    }

    axios
      .get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const hubs = response.data.hubs;

        if (!Array.isArray(hubs)) {
          console.error("Unexpected data format from API", response.data);
          return;
        }

        // Filter only active hubs
        const activeHubs = hubs.filter(
          (hub) => hub.status && hub.status.toLowerCase() === "active",
        );

        setHubCount(activeHubs.length); // Set active hub count

        // If API provides total count separately, you can set it here
        // setHubCount(response.data.hubCount);
      })
      .catch((error) => {
        console.error("Error fetching hub count:", error);
      });
  }, [rerendarApi, token]); // Include `token` in dependencies

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole"); // Get user role

    if (!token) {
      console.error("No token found");
      return;
    }

    // Determine API URL based on user role
    let apiUrl;
    if (userRole === "superadmin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/clients`;
    } else if (userRole === "admin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/clients`;
    } else {
      console.error("Unauthorized role:", userRole);
      return;
    }

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const clients = response.data.clients;

        if (!Array.isArray(clients)) {
          console.error("Unexpected data format from API", response.data);
          return;
        }

        // Filter only active clients
        const activeClients = clients.filter(
          (client) => client.status && client.status.toLowerCase() === "active",
        );

        setClientCount(activeClients.length); // Set active client count

        // If API provides total count separately, you can set it here
        // setClientCount(response.data.clientCount);
      })
      .catch((error) => {
        console.error("Error fetching client count:", error);
      });
  }, [rerendarApi, token]); // Include `token` in dependencies to ensure updates when user changes

  // Log vehicleCount to see if it updates
  useEffect(() => {}, [clientCount]);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const userRole = localStorage.getItem("userRole");

  //   if (!token) {
  //     console.error("No token found");
  //     return;
  //   }

  //   if (userRole !== "admin" && userRole !== "superadmin") {
  //     console.error("Unauthorized role:", userRole);
  //     return;
  //   }

  //   const now = new Date();
  //   const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  //   const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of the month

  //   const formatDate = (date) => {
  //     const year = date.getFullYear();
  //     const month = `0${date.getMonth() + 1}`.slice(-2);
  //     const day = `0${date.getDate()}`.slice(-2);
  //     return `${year}-${month}-${day}`;
  //   };

  //   const dateFrom = formatDate(firstDay);
  //   const dateTo = formatDate(lastDay);

  //   console.log("FROM DATE REVENUE", dateFrom);
  //   console.log("TO DATE REVENUE", dateTo);

  //   const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate-payouts/hub-summary?dateFrom=${dateFrom}&dateTo=${dateTo}`;

  //   axios
  //     .get(apiUrl, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       const hubSummary = response.data.hubSummary;

  //       if (!Array.isArray(hubSummary)) {
  //         console.error("Unexpected hubSummary format", response.data);
  //         return;
  //       }

  //       const total = hubSummary.reduce((sum, hub) => {
  //         let payout = hub.totalPayout || 0;

  //         if (payout === 0 && hub.totalAmount && hub.totalAmount > 0) {
  //           payout = hub.totalAmount;
  //         }

  //         return sum + payout;
  //       }, 0);

  //       setRevenueCount(total);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching total payout:", error);
  //     });
  // }, [rerendarApi]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole");

    if (!token) return;
    if (userRole !== "admin" && userRole !== "superadmin") return;

    const now = new Date();
    const month = `0${now.getMonth() + 1}`.slice(-2); // 01–12
    const year = now.getFullYear();

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/orders/user-payout/summary?month=${month}&year=${year}`;

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const payoutSummary = response.data?.payoutSummary;

        if (!payoutSummary) {
          console.error("Invalid payoutSummary format");
          return;
        }

        // ✅ MONTHLY REVENUE
        const monthlyRevenue = payoutSummary.totalPayout || 0;

        setRevenueCount(monthlyRevenue);

        // ✅ Fixed Revenue (month)
        const fixedRevenue = payoutSummary.totalFixedPayout || 0;

        setFixedRevenueCount(fixedRevenue);

        // Fixed Trips
        const fixedTrips = payoutSummary.fixedTrips || 0;
        setFixedTripsCount(fixedTrips);

        // ✅ PP Revenue (month)
        const ppRevenue = payoutSummary.totalPPPayout || 0;

        setPpRevenueCount(ppRevenue);

        // PP Trips
        const ppTrips = payoutSummary.ppTrips || 0;
        setPpTripsCount(ppTrips);

        // ✅ DAILY REVENUE
        const today = new Date().toISOString().split("T")[0];

        const todayData = payoutSummary.dateTotals?.find(
          (item) => item.date === today,
        );

        const todayRevenue = todayData?.totalAmount || 0;

        setDailyRevenue(todayRevenue);
      })
      .catch((error) => {
        console.error("Error fetching revenue:", error);
      });
  }, [rerendarApi]);

  useEffect(() => {}, [revenueCount]);

  //To fetch Background verification
  useEffect(() => {
    const fetchCompliances = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) return;

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/compliances`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const compliances = response.data.compliances || [];

        // Count users where idfyVerified === true
        const verifiedCount = compliances.filter(
          (item) => item.idfyVerified === true,
        ).length;

        setComplianceCount(verifiedCount);
      } catch (error) {
        console.error("Error fetching compliances:", error);
      }
    };

    fetchCompliances();
  }, []);

  //Expense -
  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        // Current Month (1st day of month → Today)
        const fromDate = moment().startOf("month").format("YYYY-MM-DD");

        const toDate = moment().format("YYYY-MM-DD");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/expenses/hubByDate`,
          {
            params: {
              fromDate,
              toDate,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data?.data || [];

        let direct = 0;
        let indirect = 0;

        data.forEach((hub) => {
          Object.values(hub.expensesByCategory || {}).forEach((cat) => {
            const type = cat.expense?.[0]?.id_expenseCategory?.type;
            const amount = cat.summary?.debitAmount || 0;

            if (type === "Direct") {
              direct += amount;
            } else if (type === "Indirect") {
              indirect += amount;
            }
          });
        });

        setDirectExpense(direct);
        setIndirectExpense(indirect);

        console.log("Direct Expense:", direct);
        console.log("Indirect Expense:", indirect);
      } catch (error) {
        console.error("Error fetching expenses:", error);
      }
    };

    fetchExpenses();
  }, []);

  //Client In/Out
  useEffect(() => {
    const fetchShiftSummary = async () => {
      try {
        const token = localStorage.getItem("token");

        const today = moment().format("YYYY-MM-DD");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-tracking/vehicle-locations?date=${today}&page=1&limit=10`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const summary = response.data?.shiftSummary;

        if (summary) {
          setEarlyCount(summary.early || 0);
          setLateCount(summary.late || 0);
          setOnTimeCount(summary.onTime || 0);
        }
      } catch (error) {
        console.error("Error fetching shift summary:", error);
      }
    };

    fetchShiftSummary();
  }, []);

  //General Staff
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/v1/general-staffs `, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setGeneralStaffCount(response.data.generalStaffCount);
      })
      .catch((error) => {
        console.error("Error fetching general staff count:", error);
      });
  }, [rerendarApi]);
  useEffect(() => {}, [generalStaffCount]);

  // Log vehicleCount to see if it updates
  useEffect(() => {}, [generalStaffCount]);

  useEffect(() => {
    setData({ cron1: "cron 1", cron2: "cron 2" });
  }, [rerendarApi]);
  // copy cron
  const copyLink = () => {
    navigator.clipboard.writeText(data.cron1);
    setRerendarApi(!rerendarApi);
    Swal.fire("Copy Cron Url", "", "success");
  };
  const copyLink2 = () => {
    navigator.clipboard.writeText(data.cron2);
    setRerendarApi(!rerendarApi);
    Swal.fire("copy success", "", "success");
  };
  // const highestRevenue = Math.max(...weeklyTrend.map((item) => item.total));

  // const highestRevenueDay = weeklyTrend.find(
  //   (item) => item.total === highestRevenue,
  // );

  const revenueChartData = {
    labels: [...weeklyTrend]
      .reverse()
      .map((item) => moment(item.date).format("DD MMM")),

    datasets: [
      {
        // data: [...weeklyTrend].reverse().map((item) => Math.round(item.total)),
        data: [...weeklyTrend]
          .reverse()
          .map((item) => Math.round(item.revenue)),

        borderColor: "#2563EB",

        backgroundColor: "rgba(37,99,235,.10)",

        fill: true,

        tension: 0.45,

        borderWidth: 4,

        pointRadius: (context) => {
          return context.raw === peakRevenue ? 9 : 5;
        },

        pointHoverRadius: 10,

        pointBackgroundColor: (context) => {
          return context.raw === peakRevenue ? "#16A34A" : "#2563EB";
        },

        pointBorderColor: "#fff",

        pointBorderWidth: 3,
      },
    ],
  };

  const revenueChartOptions = {
    responsive: true,

    maintainAspectRatio: false,

    interaction: {
      mode: "index",

      intersect: false,
    },

    plugins: {
      legend: {
        display: false,
      },

      title: {
        display: true,

        text: "Revenue Trend (Last 7 Days)",

        font: {
          size: 18,

          weight: "bold",
        },
      },

      tooltip: {
        backgroundColor: "#111827",

        padding: 14,

        callbacks: {
          label(context) {
            return "Revenue : ₹ " + Math.round(context.raw).toLocaleString();
          },
        },
      },
    },

    scales: {
      x: {
        grid: {
          display: false,
        },

        ticks: {
          font: {
            size: 13,

            weight: "600",
          },
        },
      },

      y: {
        beginAtZero: true,

        // max: Math.ceil(highestRevenue / 50000) * 50000 + 25000,
        max: Math.ceil(peakRevenue / 50000) * 50000 + 25000,
        ticks: {
          stepSize: 50000,

          callback(value) {
            if (value === 0) return "₹0";

            if (value >= 100000) {
              return "₹" + (value / 100000).toFixed(1) + "L";
            }

            return "₹" + value / 1000 + "K";
          },
        },

        grid: {
          color: "#ECECEC",
        },
      },
    },
  };
  return (
    <>
      <div className="container-fluid">
        <TrackkPopup isOpen={showPopup} onClose={closePopup} />
        {showVideoPopup && (
          <div
            className="youtube-popup-overlay"
            onClick={() => setShowVideoPopup(false)}
          >
            <div
              className="youtube-popup-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="youtube-close-btn"
                onClick={() => setShowVideoPopup(false)}
              >
                ✕
              </button>

              <iframe
                src="https://www.youtube.com/embed/ukqD0hUud9U?autoplay=1"
                title="Trackk Demo"
                className="youtube-video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        )}
        <div className="row justify-content-between">
          <div
            className="col d-flex align-items-center"
            style={{ whiteSpace: "nowrap" }}
          >
            <span className="text-xl" style={{ fontSize: "150%" }}>
              Dashboard{" "}
            </span>
            {/* <button className="view-btn" onClick={openPopup}>
              View
            </button> */}
            <button
              onClick={openPopup}
              style={{
                position: "fixed",
                top: "68px",
                right: "20px",
                // backgroundColor: "#000",
                border: "none",
                padding: "10px",
                borderRadius: "50%",
                cursor: "pointer",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </div>
        </div>
        <div className="row ">
          <div className="col-lg-3 col-sm-6 col-12 d-flex">
            <Link
              to="/vehicle"
              style={{ textDecoration: "none", width: "100%" }}
            >
              <div className="dash-count">
                <div className="dash-counts">
                  <h4>
                    <CountUp end={vehicleCount} />
                  </h4>
                  <h5>Vehicles</h5>
                </div>
                <div className="dash-imgs">
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    size="2xl"
                    style={{ color: "rgba(0,0,0,.15)" }}
                  />
                </div>
              </div>
            </Link>
          </div>
          {/* <div className="col-lg-3 col-sm-6 col-12 d-flex">
            <Link
              to="/driver"
              style={{ textDecoration: "none", width: "100%" }}
            >
              <div className="dash-count das1">
                <div className="dash-counts">
                  <h4>
                    <CountUp end={driverCount} />
                  </h4>

                  <h5>Drivers</h5>
                </div>
                <div className="dash-imgs">
                  <FontAwesomeIcon
                    icon={faEyeLowVision}
                    size="lg"
                    style={{ color: "rgba(0,0,0,.15)" }}
                  />
                </div>
              </div>
            </Link>
          </div> */}
          <div className="col-lg-3 col-sm-6 col-12 d-flex">
            <Link to="/user" style={{ textDecoration: "none", width: "100%" }}>
              <div className="dash-count das3">
                <div className="dash-counts">
                  <h4>
                    <CountUp end={userCount} />
                  </h4>

                  <h5>Total Users</h5>
                </div>
                <div className="dash-imgs">
                  <FontAwesomeIcon
                    icon={faFileInvoice}
                    size="lg"
                    style={{ color: "rgba(0,0,0,.15)" }}
                  />
                </div>
              </div>
            </Link>
          </div>

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/vehicle"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das2">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={serviceCenterCount} />
                    </h4>
                    <h5>Vehicle Service_Centre</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      size="2xl"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {(userRole === "superadmin" || userRole === "admin") && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/client"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das1">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={clientCount} />
                    </h4>
                    <h5>Clients</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          <div className="col-lg-3 col-sm-6 col-12 d-flex">
            <div className="dash-count das3">
              <div className="dash-counts">
                <h4>
                  <CountUp end={totalKm} />
                </h4>

                <h5>Total Kilometers</h5>
              </div>
              <div className="dash-imgs">
                <FontAwesomeIcon
                  icon={faFileInvoice}
                  size="lg"
                  style={{ color: "rgba(0,0,0,.15)" }}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-12 d-flex">
            <div className="dash-count das3">
              <div className="dash-counts">
                <h4>
                  <CountUp end={dailyKm} />
                </h4>

                <h5>Daily Kilometers</h5>
              </div>
              <div className="dash-imgs">
                <FontAwesomeIcon
                  icon={faFileInvoice}
                  size="lg"
                  style={{ color: "rgba(0,0,0,.15)" }}
                />
              </div>
            </div>
          </div>

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                // to="/lease"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das3">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={dailyRevenue} />
                    </h4>
                    {/* <h4>
                      <CountUp end={leaseCount} />
                    </h4> */}

                    <h5>Daily Revenue</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link style={{ textDecoration: "none", width: "100%" }}>
                <div className="dash-count das3">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={revenueCount} />
                    </h4>
                    <h5>Current Month Revenue </h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/vehiclerevenue"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das1">
                  <div className="dash-counts">
                    {/* <h4>
                      <CountUp end={fixedrevenueCount} />
                    </h4> */}
                    <h4>
                      <CountUp end={fixedrevenueCount} /> / {fixedTripsCount}
                    </h4>
                    <h5>Fixed Clients Revenue / Trips </h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      size="2xl"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/vehiclerevenue"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das2">
                  <div className="dash-counts">
                    {/* <h4>
                      <CountUp end={pprevenueCount} />
                    </h4>
                    <h5>PP Clients Revenue </h5> */}
                    <h4>
                      <CountUp end={pprevenueCount} /> / {ppTripsCount}
                    </h4>
                    <h5>PP Clients Revenue / Trips</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/compliance"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={complianceCount} />
                    </h4>
                    <h5>Background Verification </h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {userRole === "superadmin" && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/expensereport"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das1">
                  <div className="dash-counts">
                    <h4>
                      ₹{directExpense.toLocaleString()} / ₹
                      {indirectExpense.toLocaleString()}
                    </h4>

                    <h5>Direct Expense / Indirect Expense </h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {(userRole === "superadmin" || userRole === "admin") && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/clientinout"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das3">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={earlyCount} />
                    </h4>
                    <h5>Vehicle Early Arrivals (Client)</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {(userRole === "superadmin" || userRole === "admin") && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/clientinout"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das3">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={onTimeCount} />
                    </h4>
                    <h5>Vehicle On-Time Arrivals (Client)</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {(userRole === "superadmin" || userRole === "admin") && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/clientinout"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das1">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={lateCount} />
                    </h4>
                    <h5>Vehicle Late Arrivals (Client)</h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}

          {(userRole === "superadmin" || userRole === "admin") && (
            <div className="col-lg-3 col-sm-6 col-12 d-flex">
              <Link
                to="/lease"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <div className="dash-count das1">
                  <div className="dash-counts">
                    <h4>
                      <CountUp end={leaseCount} />
                    </h4>
                    <h5>Lease </h5>
                  </div>
                  <div className="dash-imgs">
                    <FontAwesomeIcon
                      icon={faEyeLowVision}
                      size="lg"
                      style={{ color: "rgba(0,0,0,.15)" }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          )}
          {userRole === "superadmin" && (
            <div className="row mt-4">
              <div className="col-12">
                <div
                  className="card shadow border-0"
                  style={{
                    borderRadius: "14px",
                    overflow: "hidden",
                  }}
                >
                  {/* Header */}
                  <div
                    className="card-header bg-white"
                    style={{
                      borderBottom: "2px solid #f1f3f5",
                      padding: "18px 24px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h4 className="fw-bold mb-1">
                          📈 Revenue Performance Trend
                        </h4>

                        <small className="text-muted">
                          Benchmark against highest revenue (
                          {moment(peakRevenueDate).format("DD MMM YYYY")})
                        </small>
                      </div>

                      <div
                        className="d-flex align-items-center justify-content-end"
                        style={{ gap: "28px" }}
                      >
                        {/* <button
                          className="btn btn-outline-primary btn-sm"
                          style={{ borderRadius: "20px" }}
                          onClick={() => setShowRevenueTrend(true)}
                        >
                          <i className="fa fa-eye me-1"></i>
                          View Trend
                        </button>{" "} */}
                        <div
                          className="d-flex align-items-end"
                          style={{ gap: "14px", marginBottom: 0 }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div>
                              <label className="small mb-1">From</label>

                              <input
                                type="date"
                                className="form-control form-control-sm"
                                style={{ width: "140px" }}
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </div>

                            <div>
                              <label className="small mb-1">To</label>

                              <input
                                type="date"
                                className="form-control form-control-sm"
                                style={{ width: "140px" }}
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                            </div>
                          </div>

                          <button
                            className="btn btn-primary btn-sm"
                            style={{
                              borderRadius: "6px",
                              padding: "6px 15px",
                              marginLeft: "10px",
                            }}
                            onClick={exportRevenueTrend}
                          >
                            <i className="fa fa-download me-2"></i>
                            Export To Excel
                          </button>
                        </div>
                        <div className="text-end">
                          <small className="text-muted d-block">
                            Peak Revenue
                          </small>

                          <h5 className="fw-bold text-success mb-0">
                            {/* ₹ {highestRevenue.toLocaleString()} */}₹{" "}
                            {peakRevenue.toLocaleString()}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table table-hover table-sm align-middle mb-0"
                      style={{
                        tableLayout: "fixed",
                      }}
                    >
                      {" "}
                      <thead
                        style={{
                          background: "#F8F9FA",
                        }}
                      >
                        <tr>
                          <th style={{ width: "16%" }} className="ps-4 py-2">
                            Date
                          </th>

                          <th
                            style={{ width: "16%" }}
                            className="text-end py-2"
                          >
                            Revenue
                          </th>

                          <th
                            style={{ width: "12%" }}
                            className="text-center py-2"
                          >
                            Total Trips
                          </th>

                          <th
                            style={{ width: "12%" }}
                            className="text-center py-2"
                          >
                            Fixed Trips
                          </th>

                          <th
                            style={{ width: "8%" }}
                            className="text-center py-2"
                          >
                            PP Trips
                          </th>

                          <th
                            style={{ width: "14%" }}
                            className="text-end py-2"
                          >
                            Fixed Amount
                          </th>

                          <th
                            style={{ width: "12%" }}
                            className="text-end py-2"
                          >
                            PP Amount
                          </th>

                          <th
                            style={{ width: "18%" }}
                            className="text-center py-2"
                          >
                            Performance
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {weeklyTrend.map((item) => {
                          {
                            /* const change =
                            ((item.total - highestRevenue) / highestRevenue) *
                            100; */
                          }

                          let bg = "#ffffff";

                          let revenueColor = "#212529";

                          let performance = null;
                          {
                            /* if (item.total === highestRevenue) { */
                          }
                          if (item.isPeakRevenue) {
                            bg = "#DCFCE7";
                            revenueColor = "#15803D";

                            performance = (
                              <span
                                className="badge"
                                style={{
                                  background: "#16A34A",
                                  color: "#fff",
                                  fontSize: "13px",
                                  padding: "7px 12px",
                                }}
                              >
                                🏆 Peak Revenue
                              </span>
                            );
                          } else if (item.performance > -10) {
                            bg = "#F0FDF4";
                            revenueColor = "#15803D";

                            performance = (
                              <span
                                style={{
                                  color: "#15803D",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(item.performance).toFixed(1)}%
                              </span>
                            );
                          } else if (item.performance > -30) {
                            bg = "#FEFCE8";
                            revenueColor = "#CA8A04";

                            performance = (
                              <span
                                style={{
                                  color: "#CA8A04",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(item.performance).toFixed(1)}%
                              </span>
                            );
                          } else {
                            bg = "#FEF2F2";
                            revenueColor = "#DC2626";

                            performance = (
                              <span
                                style={{
                                  color: "#DC2626",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(item.performance).toFixed(1)}%
                              </span>
                            );
                          }
                          {
                            /* else if (change > -10) {
                            bg = "#F0FDF4";

                            revenueColor = "#15803D";

                            performance = (
                              <span
                                style={{
                                  color: "#15803D",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(change).toFixed(1)}%
                              </span>
                            );
                          } else if (change > -30) {
                            bg = "#FEFCE8";

                            revenueColor = "#CA8A04";

                            performance = (
                              <span
                                style={{
                                  color: "#CA8A04",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(change).toFixed(1)}%
                              </span>
                            );
                          } else {
                            bg = "#FEF2F2";

                            revenueColor = "#DC2626";

                            performance = (
                              <span
                                style={{
                                  color: "#DC2626",
                                  fontWeight: 700,
                                }}
                              >
                                ▼ {Math.abs(change).toFixed(1)}%
                              </span>
                            );
                          } */
                          }

                          return (
                            <tr
                              key={item.date}
                              style={{
                                background: bg,
                                transition: ".25s",
                                height: "46px",
                              }}
                            >
                              <td className="ps-4 fw-semibold">
                                {moment(item.date).format("DD MMM YYYY")}
                              </td>

                              <td
                                className="text-end fw-bold"
                                style={{
                                  color: revenueColor,
                                  fontSize: "15px",
                                }}
                              >
                                ₹ {item.revenue.toLocaleString()}{" "}
                              </td>

                              <td className="text-center fw-semibold">
                                {/* {item.trips} */}
                                {item.totalTrips}{" "}
                              </td>

                              <td className="text-center">{item.fixedTrips}</td>
                              {/* 
                            <td className="text-center">{item.ppTrips}</td>

                            <td className="text-center">{performance}</td> */}

                              <td className="text-center">{item.ppTrips}</td>

                              <td
                                className="text-end fw-semibold"
                                style={{ color: "#2563EB" }}
                              >
                                {/* ₹ {Math.round(item.fixed).toLocaleString()} */}
                                ₹{" "}
                                {Math.round(item.fixedAmount).toLocaleString()}
                              </td>

                              <td
                                className="text-end fw-semibold"
                                style={{ color: "#7C3AED" }}
                              >
                                {/* ₹ {Math.round(item.pp).toLocaleString()} */}
                                ₹ {Math.round(item.ppAmount).toLocaleString()}
                              </td>

                              <td className="text-center">{performance}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row">
            {/* Container for both Pie charts */}
            <div className="card me-2" style={{ flex: "1 1 45%" }}>
              <div className="card-body">
                <h5>
                  <b>General Staff Attendance (Present vs Absent)</b>
                </h5>
                <br />
                {/* Container for Pie Chart and Legend */}
                <div className="chart-container">
                  <div className="pie-chart" style={{ marginRight: "30px" }}>
                    <Pie data={userStatusChartData} options={options} />
                  </div>
                  <div className="legend-container">
                    {userStatusChartData.labels &&
                      userStatusChartData.labels.map((label, index) => {
                        const count =
                          userStatusChartData.datasets[0].data[index]; // Get count for the label
                        const total =
                          userStatusChartData.datasets[0].data.reduce(
                            (sum, value) => sum + value,
                            0,
                          ); // Total users
                        const percentage = total
                          ? ((count / total) * 100).toFixed(2)
                          : 0; // Calculate percentage

                        return (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  userStatusChartData.datasets[0]
                                    .backgroundColor[index],
                              }}
                            ></span>
                            {`${label} : ${count} (${percentage}%)`}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            {/* Pie Chart for Status */}
            <div className="card" style={{ flex: "1 1 45%" }}>
              <div className="card-body">
                <h5>
                  <b>Drivers Attendance (Present vs Absent)</b>
                </h5>
                <br />
                <div className="chart-container">
                  <div className="pie-chart" style={{ marginRight: "30px" }}>
                    <Pie data={driverStatusChartData} options={options} />
                  </div>
                  <div className="legend-container">
                    {driverStatusChartData.labels &&
                      driverStatusChartData.labels.map((label, index) => {
                        const count =
                          driverStatusChartData.datasets[0].data[index];
                        const total =
                          driverStatusChartData.datasets[0].data.reduce(
                            (sum, val) => sum + val,
                            0,
                          );
                        const percentage = total
                          ? ((count / total) * 100).toFixed(2)
                          : 0;

                        return (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  driverStatusChartData.datasets[0]
                                    .backgroundColor[index],
                              }}
                            ></span>
                            {`${label} : ${count} (${percentage}%)`}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mb-4 d-flex justify-content-between">
              {/* Pie chart for Vehicle Companies */}
              <div className="card me-2" style={{ flex: "1 1 45%" }}>
                <div className="card-body">
                  <h5>
                    <b>Vehicle Distribution by Company</b>
                  </h5>
                  <br />
                  {/* Container for Pie Chart and Legend */}
                  <div className="chart-container">
                    <div className="pie-chart" style={{ marginRight: "30px" }}>
                      <Pie data={chartData} options={options} />
                    </div>
                    <div className="legend-container">
                      {chartData.labels &&
                        chartData.labels.map((label, index) => {
                          const count = chartData.datasets[0].data[index]; // Get count for the label
                          const total = chartData.datasets[0].data.reduce(
                            (sum, value) => sum + value,
                            0,
                          ); // Total vehicles
                          const percentage = total
                            ? ((count / total) * 100).toFixed(2)
                            : 0; // Calculate percentage

                          return (
                            <div key={index} className="legend-item">
                              <span
                                className="legend-color"
                                style={{
                                  backgroundColor:
                                    chartData.datasets[0].backgroundColor[
                                      index
                                    ],
                                }}
                              ></span>
                              {`${label} : ${count} (${percentage}%)`}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>

              {/* Pie Chart for Status */}
              <div className="card" style={{ flex: "1 1 45%" }}>
                {/* <div className="card-body">
                  <h5>
                    <b>Vehicle Distribution by Status</b>
                  </h5>
                  <br />
                  <div className="chart-container">
                    <div className="pie-chart" style={{ marginRight: "30px" }}>
                      <Pie data={statusChartData} options={options} />
                    </div>
                    <div className="legend-container">
                      {statusChartData.labels &&
                        statusChartData.labels.map((label, index) => {
                          const count = statusChartData.datasets[0].data[index]; // Get count for the label
                          const total = statusChartData.datasets[0].data.reduce(
                            (sum, value) => sum + value,
                            0
                          ); // Total vehicles
                          const percentage = total
                            ? ((count / total) * 100).toFixed(2)
                            : 0; // Calculate percentage

                          return (
                            <div key={index} className="legend-item">
                              <span
                                className="legend-color"
                                style={{
                                  backgroundColor:
                                    statusChartData.datasets[0].backgroundColor[
                                      index
                                    ],
                                }}
                              ></span>
                              {`${label} : ${count} (${percentage}%)`}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div> */}
                <div className="card-body">
                  <h5>
                    <b>Vehicle Moving and Not Moving Status</b>
                  </h5>
                  <br />
                  <div className="chart-container">
                    <div className="pie-chart" style={{ marginRight: "30px" }}>
                      <Pie data={vehiclestatusChartData} options={options} />
                    </div>
                    <div className="legend-container">
                      {vehiclestatusChartData.labels.map((label, index) => {
                        const count =
                          vehiclestatusChartData.datasets[0].data[index]; // Get count for the label
                        const total =
                          vehiclestatusChartData.datasets[0].data.reduce(
                            (sum, value) => sum + value,
                            0,
                          ); // Total vehicles
                        const percentage = total
                          ? ((count / total) * 100).toFixed(2)
                          : 0; // Calculate percentage

                        return (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  vehiclestatusChartData.datasets[0]
                                    .backgroundColor[index],
                              }}
                            ></span>
                            {`${label} : ${count} (${percentage}%)`}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mb-4 d-flex justify-content-between">
              <div className="card me-2" style={{ flex: "1 1 45%" }}>
                <div className="card-body">
                  <h5>
                    <b>Moving Vehicles by Company</b>
                  </h5>
                  <br />
                  {/* Container for Pie Chart and Legend */}
                  <div className="chart-container">
                    <div
                      className="pie-chart"
                      style={{
                        width: "300px",
                        height: "300px",
                        marginRight: "30px",
                      }}
                    >
                      <Pie data={movingChartData} options={options} />
                    </div>
                    <div className="legend-container">
                      {movingChartData.labels.map((label, index) => {
                        const count = movingChartData.datasets[0].data[index];
                        const total = movingChartData.datasets[0].data.reduce(
                          (sum, value) => sum + value,
                          0,
                        );
                        const percentage = total
                          ? ((count / total) * 100).toFixed(2)
                          : 0;

                        return (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  movingChartData.datasets[0].backgroundColor[
                                    index
                                  ],
                              }}
                            ></span>
                            {`${label}: ${count} (${percentage}%)`}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" style={{ flex: "1 1 45%" }}>
                <div className="card-body">
                  <h5>
                    <b>Not-Moving Vehicles by Company</b>
                  </h5>
                  <br />
                  {/* Container for Pie Chart and Legend */}
                  <div className="chart-container">
                    <div className="pie-chart" style={{ marginRight: "30px" }}>
                      <Pie data={notMovingChartData} options={options} />
                    </div>
                    <div className="legend-container">
                      {notMovingChartData.labels.map((label, index) => {
                        const count =
                          notMovingChartData.datasets[0].data[index];
                        const total =
                          notMovingChartData.datasets[0].data.reduce(
                            (sum, value) => sum + value,
                            0,
                          );
                        const percentage = total
                          ? ((count / total) * 100).toFixed(2)
                          : 0;

                        return (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  notMovingChartData.datasets[0]
                                    .backgroundColor[index],
                              }}
                            ></span>
                            {`${label}: ${count} (${percentage}%)`}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* CROSS UTILIZATION */}
            {/* <div className="card me-2" style={{ flex: "1 1 100%" }}>
              <div className="card-body">
                <h5>
                  <b>Monthly Cross Utilization (Line Chart)</b>
                </h5>
                <br />
                {crossUtilizationChartData.labels.length > 0 ? (
                  <Line data={crossUtilizationChartData} options={option} />
                ) : (
                  <p>Loading chart...</p>
                )}
              </div>
            </div> */}
          </div>

          {/* {userRole === "superadmin" && (
            <div className="col-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <h5>
                    <b>Vehicle Status by Company</b>
                  </h5>
                  <br />
                  <div className="chart-container">
                    <Bar
                      data={barChartData}
                      options={{
                        responsive: true,
                        scales: {
                          x: {
                            stacked: true,
                          },
                          y: {
                            stacked: true,
                            beginAtZero: true,
                          },
                        },
                        plugins: {
                          legend: {
                            display: true, // Display the legend
                          },
                          tooltip: {
                            callbacks: {
                              label: (context) => {
                                const datasetLabel =
                                  context.dataset.label || "";
                                const value = context.raw || 0;
                                return `${datasetLabel}: ${value}`;
                              },
                            },
                          },
                          datalabels: {
                            display: true, // Display the labels
                            color: "white", // Color of the label text
                            align: "center",
                            anchor: "center",
                            font: {
                              weight: "bold", // Bold text
                            },
                            formatter: (value, context) => {
                              const datasetLabel = context.dataset.label || "";
                              return value > 0
                                ? `${datasetLabel} - ${value}`
                                : ""; // Format as "Active - 10"
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )} */}
          <div className="card-body">
            <MyMapComponent />
          </div>
        </div>
      </div>
      {/* <button
        className="trackk-slider-btn"
        onClick={() => setShowTrackkPanel(!showTrackkPanel)}
      >
        {showTrackkPanel ? "→" : "←"}
      </button> */}

      <div className="trackk-floating-buttons">
        {/* YouTube Demo Button */}
        <button
          className="trackk-demo-btn"
          onClick={() => setShowVideoPopup(true)}
          title="Watch Trackk Demo"
        >
          ▶
        </button>

        {/* Existing Slider Button */}
        <button
          className="trackk-slider-btn"
          onClick={() => setShowTrackkPanel(!showTrackkPanel)}
        >
          {showTrackkPanel ? "→" : "←"}
        </button>
      </div>

      <div className={`trackk-side-panel ${showTrackkPanel ? "open" : ""}`}>
        <div className="panel-header">
          <h4>Trackk Capabilities</h4>
          <button onClick={() => setShowTrackkPanel(false)}>✕</button>
        </div>

        <div className="panel-content">
          <div className="trackk-hero">
            <h3>10+ Automation Workflows</h3>
            <p>Fleet · HR · Revenue · Compliance · Tracking</p>
          </div>

          <div className="section">
            <h5>Integrations</h5>

            <div className="feature-card inprogress">
              <div className="card-icon blue">📄</div>
              <div>
                <strong>Challan Integrations</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon purple">🛡️</div>
              <div>
                <strong>Background Verification</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon green">📍</div>
              <div>
                <strong>GPS Integrations</strong>
                <small>Euler · Eicher · Montra · IXEnergy · Jupiter</small>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon indigo">💬</div>
              <div>
                <strong>Slack Integrations</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon pink">📷</div>
              <div>
                <strong>Camera Based Detection</strong>
              </div>
            </div>

            <div className="feature-card inprogress">
              <div className="card-icon teal">🌱</div>
              <div>
                <strong>Carbon Credits</strong>
              </div>
              <span className="badge-inprogress">In Progress</span>
            </div>

            <div className="feature-card">
              <div className="card-icon orange">🔔</div>
              <div>
                <strong>Notification Matrix</strong>
              </div>
            </div>

            <div className="feature-card inprogress">
              <div className="card-icon yellow">📡</div>
              <div>
                <strong>SIM Based Tracking</strong>
              </div>
              <span className="badge-inprogress">In Progress</span>
            </div>
          </div>

          <div className="section">
            <h5>Automated Processes</h5>

            <div className="feature-card">
              <div className="card-icon green">💰</div>
              <div>
                <strong>Auto Salary Calculations</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon blue">🧾</div>
              <div>
                <strong>Auto Invoice Calculations</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon orange">🚚</div>
              <div>
                <strong>Trips & Revenue via Attendance</strong>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon red">📍</div>
              <div>
                <strong>Fake Location Detection</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showRevenueTrend}
        onHide={() => setShowRevenueTrend(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Revenue Trend</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ height: "700px" }}>
            <Line data={revenueChartData} options={revenueChartOptions} />
          </div>{" "}
        </Modal.Body>
      </Modal>
    </>
  );
}
